const ISDashboardTabs = {
  FOLLOW_UP: 'FOLLOW_UP',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  CONTRACTS_MANAGER: 'CONTRACTS_MANAGER',
  LEADS_CONTACTED: 'LEADS_CONTACTED',
};

export default ISDashboardTabs;
